import React from "react";
import { CircularProgress } from "@mui/material";
import {
  BotaoBaseAzulPreenchido,
  BotaoBaseAzulSemFundo,
  BotaoBaseAzulVazado,
  BotaoBaseVerdePreenchido,
  BotaoBaseVerdeSemFundo,
  BotaoBaseVerdeVazado,
  BotaoBaseVermelhoPreenchido,
  BotaoBaseVermelhoSemFundo,
  BotaoBaseVermelhoVazado,
  Icone,
  ItemVazio,
  Linha,
  TextoBotao,
} from "./styles";
import Save from "@mui/icons-material/Download";
import { useTheme } from "@emotion/react";

const definirTamanho = (tamanho) => {
  switch (tamanho) {
    case "SM":
      return {
        minWidth: 120,
        height: 32,
        padding: " 8px 16px 8px 16px",
        fontSize: "16px",
      };
    case "MD":
      return {
        minWidth: 140,
        height: 40,
        padding: " 8px 24px 8px 24px",
        fontSize: "16px",
      };
    case "LG":
      return {
        minWidth: 204,
        height: 48,
        padding: " 8px 24px 8px 24px",
        fontSize: "20px",
      };
    default:
      return {
        minWidth: 140,
        height: 40,
        padding: " 8px 24px 8px 24px",
        fontSize: "16px",
      };
  }
};

const definirTamanhoComIcone = ({ icone, iconeFinal }) => {
  if (icone) {
    return {
      minWidth: "fit-content",
      padding: "8px 32px 8px 24px",
    };
  }
  if (iconeFinal) {
    return {
      minWidth: "fit-content",
      padding: "8px 24px 8px 32px",
    };
  }
};

///// Botao Azul
export const BotaoAzulPreenchido = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
  disabled,
  loading,
  cor,
  tabindex,
  refs,
  className = "",
}) => {
  return texto != "" ? (
    <BotaoBaseAzulPreenchido
      className={`${className} btnGravarItem`}
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
      disabled={disabled || loading}
      texto={texto}
      cor={cor}
      tabIndex={tabindex}
      ref={refs}
    >
      <Linha>
        {loading ? (
          <CircularProgress size={16} style={{ color: "inherit", marginRight: texto != "vazio" ? 8 : 0 }} />
        ) : icone && (
          <Icone
            style={{ marginRight: texto != "vazio" ? 8 : 0 }}
            margin={texto != "vazio" ? true : false}
          >
            {icone}
          </Icone>
        )}
        {texto != "vazio" ? <TextoBotao>{texto}</TextoBotao> : ""}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseAzulPreenchido>
  ) : (
    <ItemVazio
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
    />
  );
};

export const BotaoAzulVazado = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
  disabled,
  className,
  larguraAdaptavel = false,
}) => {
  return texto != "" ? (
    <BotaoBaseAzulVazado
      className={className}
      disabled={disabled}
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...{ minWidth: larguraAdaptavel ? "fit-content" : undefined },
        ...style,
      }}
      onClick={onClick}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        <TextoBotao>{texto}</TextoBotao>
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseAzulVazado>
  ) : (
    <ItemVazio
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
    />
  );
};

export const BotaoAzulSemFundo = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
  disabled = false,
}) => {
  return (
    <BotaoBaseAzulSemFundo
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      disabled={disabled}
      onClick={onClick}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        {texto}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseAzulSemFundo>
  );
};

///// Botao Vermelho

export const BotaoVermelhoPreenchido = ({
  className,
  texto,
  icone,
  iconeFinal,
  disabled,
  tamanho,
  style = {},
  onClick,
}) => {
  return (
    <BotaoBaseVermelhoPreenchido
      className={className}
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        <div style={{ fontSize: 15 }}>{texto}</div>
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseVermelhoPreenchido>
  );
};

export const BotaoVermelhoVazado = ({
  texto,
  icone,
  iconeFinal,
  disabled,
  tamanho,
  style = {},
  onClick,
  refs,
}) => {
  return (
    <BotaoBaseVermelhoVazado
      ref={refs}
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        <TextoBotao>{texto}</TextoBotao>
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseVermelhoVazado>
  );
};

export const BotaoVermelhoSemFundo = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
  refs,
}) => {
  return (
    <BotaoBaseVermelhoSemFundo
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
      ref={refs}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        {texto}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseVermelhoSemFundo>
  );
};

///// Botao Verde

export const BotaoVerdePreenchido = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
  disabled,
  tabindex,
  refs,
}) => {
  const theme = useTheme();

  return (
    <BotaoBaseVerdePreenchido
      className="btnGravarItem"
      ref={refs}
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
      tabIndex={parseInt(tabindex) ? parseInt(tabindex) : 0}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
        <TextoBotao>{texto}</TextoBotao>
      </Linha>
    </BotaoBaseVerdePreenchido>
  );
};

export const BotaoVerdeVazado = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
}) => {
  return (
    <BotaoBaseVerdeVazado
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        {texto}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseVerdeVazado>
  );
};

export const BotaoVerdeSemFundo = ({
  texto,
  icone,
  iconeFinal,
  tamanho,
  style = {},
  onClick,
}) => {
  return (
    <BotaoBaseVerdeSemFundo
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone, iconeFinal }),
        ...style,
      }}
      onClick={onClick}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            {icone}
          </Icone>
        )}
        {texto}
        {iconeFinal && (
          <Icone style={{ marginLeft: texto != "vazio" ? 8 : 0 }}>
            {iconeFinal}
          </Icone>
        )}
      </Linha>
    </BotaoBaseVerdeSemFundo>
  );
};

export const BotaoGravar = ({
  texto,
  icone,
  tamanho,
  style = {},
  onClick,
  disabled,
  cor,
}) => {
  return texto != "" ? (
    <BotaoBaseAzulPreenchido
      className="btnGravarItem"
      style={{
        ...definirTamanho(tamanho),
        ...definirTamanhoComIcone({ icone }),
        ...style,
      }}
      onClick={onClick}
      disabled={disabled}
      texto={texto}
      cor={cor}
    >
      <Linha>
        {icone && (
          <Icone style={{ marginRight: texto != "vazio" ? 8 : 0 }}>
            <Save />
          </Icone>
        )}
      </Linha>
    </BotaoBaseAzulPreenchido>
  ) : (
    <ItemVazio style={{ ...definirTamanho(tamanho), ...style }} />
  );
};
